const clearApiCache = async () => {
  await window.caches.delete('sephora-api-v2')
}

export {
  clearApiCache
}
